import React from 'react'
import { useLocalStorage } from 'react-use'

import { Banner } from '@sketch/components'
import { LearnMoreText, UpsellWrapper } from './WorkspaceSettingsUpsell.styles'

type WorkspaceSettingsUpsellBannerProps = {
  bannerText: string
  localStorageKey: string
  ctaText: string
  ctaHref: string
}

type UpsellBannerProps = {
  setUpsellVisible: React.Dispatch<React.SetStateAction<boolean | undefined>>
  bannerText: string
  ctaText: string
  ctaHref: string
}

const UpsellBanner: React.FCC<UpsellBannerProps> = ({
  setUpsellVisible,
  bannerText,
  ctaText,
  ctaHref,
}) => {
  const onDismiss = () => setUpsellVisible(false)

  return (
    <UpsellWrapper>
      <Banner type="upsell" onDismiss={onDismiss} dismissible>
        {bannerText}{' '}
        <LearnMoreText external data-testid="learn-more" href={ctaHref}>
          {ctaText}
        </LearnMoreText>
      </Banner>
    </UpsellWrapper>
  )
}

const WorkspaceSettingsUpsellBannerContainer: React.FCC<
  WorkspaceSettingsUpsellBannerProps
> = ({ bannerText, localStorageKey, ctaText, ctaHref }) => {
  const [upsellVisible, setUpsellVisible] = useLocalStorage(
    localStorageKey,
    true
  )

  if (!upsellVisible) return null

  return (
    <UpsellBanner
      setUpsellVisible={setUpsellVisible}
      bannerText={bannerText}
      ctaText={ctaText}
      ctaHref={ctaHref}
    />
  )
}

export { WorkspaceSettingsUpsellBannerContainer as WorkspaceSettingsUpsellBanner }
